import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import SubmitCV from "./pages/SubmitCV";
import Contact from "./pages/Contact";
import { InsightsList, InsightDetail } from "./pages/Insights";
import { VacanciesList, VacancyDetail } from "./pages/Vacancies";
import { TermsUK, TermsME } from "./pages/Terms";
import Admin from "./pages/Admin";

function Shell() {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith("/admin");
  return (
    <Layout hideChrome={hideChrome}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/vacancies" element={<VacanciesList />} />
        <Route path="/vacancies/:id" element={<VacancyDetail />} />
        <Route path="/insights" element={<InsightsList />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/submit-cv" element={<SubmitCV />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms/uk" element={<TermsUK />} />
        <Route path="/terms/middle-east" element={<TermsME />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
